// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__8tlOI","title":"Images90_title__2Kw3e","images":"Images90_images__2k8Zw"};